import moment from 'jalali-moment'
interface IItemProps {
    item: IRequestMessageResult
}
export default function Item({ item }: IItemProps) {
    return (
        <>
            <div className=" my-2 text-xs text-gray-1 flex w-full px-2  justify-between">
                <p className=" text-gray-1">
                    {moment(new Date(item.timestamp * 1000))
                        .locale('fa')
                        .fromNow()}
                </p>
                <p className=" text-gray-1">
                    {moment
                        .from(item.date, 'en', 'YYYY-MM-DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')}
                </p>
            </div>
            {item.messages.map((message, index) => (
                <div className=" bg-white py-2 px-1 my-2" key={index}>
                    <div className=" w-full">
                        <p className=" text-black text-sm">{message.body}</p>
                        <div className=" w-full flex justify-end">
                            <p className=" text-gray-1 text-left text-xs mt-2">
                                {moment(new Date(message.timestamp * 1000))
                                    .locale('fa')
                                    .format('HH:mm:ss')}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}
